<template>
<v-main>
  <v-container fluid>
   
    <v-row align="center" justify="center">
      <v-col cols="12" md="4" sm="12">
        <v-card class="mx-auto" max-width="700">
          <v-card-title><h2>
            Pick Five Projects to Fund
          </h2></v-card-title> 
          <v-card-subtitle class="font-weight-medium">Out of the ten Unfunded Projects below, click on the five projects that you would like to Fund</v-card-subtitle>
          <v-spacer></v-spacer>
          <v-toolbar flat color="transparent" dense>
            <v-toolbar-title>Funded Projects </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title v-text="funded.length"></v-toolbar-title>
            <v-toolbar-title>/5</v-toolbar-title>
          </v-toolbar>
          <v-container class="py-0">
            <v-row align="center" justify="start">
              <v-col
                v-for="selection in funded"
                :key="selection.id"
                class="shrink"
              >
                <v-chip
                  :disabled="loading"
                  close
                  @click:close="removeFunded(selection)"
                  color="#C1D5C9"
                >
                  <v-icon left v-text="selection.icon"></v-icon>
                  {{ selection.text }}
                </v-chip>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-toolbar flat color="transparent" dense>
            <v-toolbar-title>Unfunded Projects</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-list>
            <template v-for="item in unfunded">
              <v-list-item
                :key="item.id"
                :disabled="loading"
                @click="chooseFunded(item)"
              >
                <v-list-item-avatar>
                  <v-icon :disabled="loading" v-text="item.icon"></v-icon>
                </v-list-item-avatar>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
          <v-divider></v-divider>

          <v-card-actions v-if="advanceRoute">
            <v-spacer></v-spacer>
            <v-btn
             
              :disabled="funded.length < 5"
              :loading="loading"
              color="#418F7B"
              text x-large
              @click="next"
            >
              Next
            </v-btn>
            <!-- <v-btn 
              v-else
              :disabled="true"
              text
            >
              Please wait for Admin to advance
            </v-btn> -->
          </v-card-actions>
          <v-card-actions v-else>
            <v-spacer></v-spacer>
            <v-btn
             
              :disabled="true"
              :loading="loading"
              color="#951B20"
              text
            >
              Please Wait
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4" sm="12">
        <v-img max-height="1024" src="@/assets/InnovationScreenBig.jpg" contain>
        </v-img>
        <!-- <v-img max-height="700" src="@/assets/projectMatrix_pn.jpg" contain>
        </v-img> -->
      </v-col>
    </v-row>
  </v-container>
  </v-main>
</template>

<script>
import { route_path } from "@/main";
export default {
  data: () => ({
    loading: false
  }),
  computed: {
    groupPlay() {
      return this.$store.getters.groupPlay;
    },
    projects() {
      return this.$store.getters.projects;
    },
    funded() {
      return this.$store.getters.projects.filter(
        element => element.funded === true
      );
    },
    unfunded() {
      return this.$store.getters.projects.filter(
        element => element.funded === false
      );
    },
    currentRouteName() {
      return this.$route.path;
    },
    currentRouteIndex() {
      const routeName = this.$route.path;
      return route_path.findIndex(p => p.path == routeName);
    },
    advanceRoute() {
      return this.$store.getters.advanceRoute(this.$route.path);
    }
  },
  methods: {
    next() {
      this.$store.dispatch("tabulateResults")
      this.$store.dispatch("savePortfolio");
      this.$store.dispatch("gameStart");
      this.$router.push("stratreview");
      
    },
    chooseFunded(item) {
      this.$store.dispatch("chooseFunded", item);
    },
    removeFunded(item) {
      this.$store.dispatch("removeFunded", item);
    }
  }
};
</script>
